import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export type SubmissionStatus = 'idle' | 'sending' | 'polling' | 'success' | 'error'

interface FormNavigationStore {
  currentStep: number
  submissionStatus: SubmissionStatus
  strictValidation: boolean
  setCurrentStep: (step: number) => void
  incrementStep: () => void
  decrementStep: () => void
  setSubmissionStatus: (status: SubmissionStatus) => void
  setStrictValidation: (value: boolean) => void
  reset: () => void
}

const INITIAL_NAV: Pick<FormNavigationStore, 'currentStep' | 'submissionStatus' | 'strictValidation'> = {
  currentStep: 0,
  submissionStatus: 'idle',
  strictValidation: false,
}

export const useFormStore = create<FormNavigationStore>()(
  persist(
    (set, get) => ({
      ...INITIAL_NAV,
      setCurrentStep: (step) => set({ currentStep: step }),
      incrementStep: () => set({ currentStep: get().currentStep + 1 }),
      decrementStep: () => set({ currentStep: get().currentStep - 1 }),
      setSubmissionStatus: (status) => set({ submissionStatus: status }),
      setStrictValidation: (value) => set({ strictValidation: value }),
      reset: () => set({ ...INITIAL_NAV }),
    }),
    {
      name: 'FORM_NAV',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ currentStep: state.currentStep }),
    }
  )
)
